// Função para mostrar o loadding
const loadding = function loadding() {
  $("html, body").css('overflow', 'hidden').fadeIn('slow');
  $(window).on('load', function () {
    $(".loader").fadeOut("slow");
    $("html, body").css('overflow', 'auto');
  });
};

// Função para loaading de components
const loaddingComponents = function loaddingComponents() {
  $("html, body").css('overflow', 'hidden').fadeIn('slow');
  $(".loader").fadeIn("slow");
  setTimeout(function () {
    $(".loader").fadeOut("slow");
    $("html, body").css('overflow', 'auto').fadeIn('slow');
  }, 1000);
}